import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { UserSetting } from './user-setting.model';

export const loadUserSettings = createAction(
    '[UserSetting/API] Load UserSettings',
    props<{ userSettings: UserSetting[] }>()
);

export const addUserSetting = createAction(
    '[UserSetting/API] Add UserSetting',
    props<{ userSetting: UserSetting }>()
);

export const upsertUserSetting = createAction(
    '[UserSetting/API] Upsert UserSetting',
    props<{ userSetting: UserSetting }>()
);

export const addUserSettings = createAction(
    '[UserSetting/API] Add UserSettings',
    props<{ userSettings: UserSetting[] }>()
);

export const upsertUserSettings = createAction(
    '[UserSetting/API] Upsert UserSettings',
    props<{ userSettings: UserSetting[] }>()
);

export const updateUserSetting = createAction(
    '[UserSetting/API] Update UserSetting',
    props<{ userSetting: Update<UserSetting> }>()
);

export const updateUserSettings = createAction(
    '[UserSetting/API] Update UserSettings',
    props<{ userSettings: Update<UserSetting>[] }>()
);

export const deleteUserSetting = createAction(
    '[UserSetting/API] Delete UserSetting',
    props<{ id: string }>()
);

export const deleteUserSettings = createAction(
    '[UserSetting/API] Delete UserSettings',
    props<{ ids: string[] }>()
);

export const clearUserSettings = createAction(
    '[UserSetting/API] Clear UserSettings'
);

export const deleteUserAIHelpButton = createAction(
    '[UserSetting/API] Delete UserAIHelpButton'
);

export const getUserSettings = createAction(
    '[UserSetting/API] Get UserSettings',
    props<{ EmployeeListID: string, EmpSettingID?: number }>()
);

export const putUserSettings = createAction(
    '[UserSetting/API] Put UserSettings',
    props<{ settings: Array<Partial<UserSetting>> }>()
);
